<template>
    <div class="footer" v-if="false">
        <div class="ah-container">
            <el-row :gutter="20">
                <el-col :sm="8">
                    <img src="@/assets/img/ahoo-logo-black.svg" style="width: 90px; opacity: 0.5;" />
                </el-col>
                <el-col :sm="8"> </el-col>
                <el-col :sm="8"> </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
    data() {
        return {};
    },
};
</script>
<style lang="scss">
.footer {
    padding-top: 6px;
    border-top: 1px solid #ccc;
}
</style>
